function ColdStorageBonds(){
     return(
           <div>  
             <h2>ColdStorageBondsk</h2>
             <p>details here</p>
            </div>
         );
}
export default ColdStorageBonds;